import PackagingMethodLevel from "../../shared/packaging/PackagingMethodLevel";
import { PackagingGate } from "../../shared/packaging/packagingLevel.types";

type PackagingMethodProps = {
  gate?: PackagingGate;
  farmGateId: string;
  packagingData: any[];
  refetchData: (...args: any[]) => any;
  packagingId: string | null;
  savePackingNodeData: (id: string, name?: string) => void;
  packagingName?: string;
  onPackagingSave?: (packagingId: string) => void;
  lockStatus?: boolean;
};

const PackagingMethod = ({ farmGateId, gate = "farm-gate", ...props }: PackagingMethodProps) => {
  return <PackagingMethodLevel gate={gate} gateId={farmGateId} {...props} />;
};

export default PackagingMethod;
